/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Suggestions_Welcome_11Inputs */

const es_chat_suggestions_welcome_11 = /** @type {(inputs: Chat_Suggestions_Welcome_11Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Empecemos cuando quieras, ${i?.name}. ¿Qué tenés en mente?`)
};

const en_chat_suggestions_welcome_11 = /** @type {(inputs: Chat_Suggestions_Welcome_11Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Let's get started, ${i?.name}. What's on your mind?`)
};

/**
* | output |
* | --- |
* | "Let's get started, {name}. What's on your mind?" |
*
* @param {Chat_Suggestions_Welcome_11Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_suggestions_welcome_11 = /** @type {((inputs: Chat_Suggestions_Welcome_11Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestions_Welcome_11Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_suggestions_welcome_11(inputs)
	return en_chat_suggestions_welcome_11(inputs)
});
export { chat_suggestions_welcome_11 as "chat.suggestions.welcome_11" }